export const paths = {
  index: "/",
  auth: {
    index: "/auth",
    login: "/auth/login",
    register: "/auth/register",
    resetPassword: "/auth/reset-password",
  },
  dashboard: {
    index: "/dashboard",
    monitoring: "/dashboard/monitoring",
    statistics: "/dashboard/statistics",
    documents: "/dashboard/documents",
    users: "/dashboard/users",
    settings: "/dashboard/settings",
    export: "/dashboard/export",
  },
  401: "/401",
  404: "/404",
  500: "/500",
};
